// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleDetail_ArticleShare_container"};